import axios from 'axios';
import {
  getAPIBaseURL,
  getAPIKey,
  getGreylockAPIBaseURL,
  getGreylockAPIKey
} from './config';

const httpEConfig = axios.create({
  baseURL: getAPIBaseURL() + '/econfigplus',
  headers: {
    //'Content-Type': 'application/json',
    'Content-Encoding': 'gzip',
    'ocp-apim-subscription-key': getAPIKey()
  }
});

const httpGreylock = axios.create({
  baseURL: getGreylockAPIBaseURL() + '/greylockplus/api',
  headers: {
    'Content-Type': 'application/json',
    'ocp-apim-subscription-key': getGreylockAPIKey()
  }
});

export { httpEConfig, httpGreylock };
